export enum SessionEvent {
    TokenMaxLifetimeReached = "tokenMaxLifetimeReached",
    TokenAutoUpdateFailed = "tokenAutoUpdateFailed"
}
